import strFunc from "@/lib/lyg/string";

function StudyTitleAswer(props: any) {
  let myProps = {
    info: {},
    daily_info: {},
    ...props
  };
  let info = myProps.info;
  let textbook_info: any = null;
  if (myProps.info["daily_textbook_arr"] && myProps.info["daily_textbook_arr"].length > 0) {
    for (let i = 0; i < myProps.info["daily_textbook_arr"].length; i++) {
      if (myProps.info["daily_textbook_arr"][i]["a_seq"] == myProps.daily_info["a_textbook_seq"]) {
        textbook_info = myProps.info["daily_textbook_arr"][i];
      }
    }
  }
  if (myProps.info["daily_study_title_arr"] && myProps.info["daily_study_title_arr"].length > 0) {
    for (let i = 0; i < myProps.info["daily_study_title_arr"].length; i++) {
      if (myProps.info["daily_study_title_arr"][i]["a_seq"] == myProps.daily_info["a_textbook_seq"]) {
        textbook_info = myProps.info["daily_study_title_arr"][i];
      }
    }
  }
  let a_book_pdf_url = "";
  let use_page_num = 1;
  if (textbook_info != null && textbook_info["a_book_pdf_url"]) {
    a_book_pdf_url = textbook_info["a_book_pdf_url"];
  }
  if (myProps.daily_info["textbook_use"] && myProps.daily_info["textbook_use"]["a_now_page"]) {
    use_page_num = myProps.daily_info["textbook_use"]["a_now_page"];
  }
  
  return (
    <div className="text-center">
      {!strFunc.is_empty(a_book_pdf_url) &&
        <button className="btn-s btn-gray"
          onClick={() => {
            let pdf_v_url = process.env.REACT_APP_API_URL + "/home/util/pdf_viewr";
            pdf_v_url += "?pdf_url=" + a_book_pdf_url + "&page=" + use_page_num;
            window.open(pdf_v_url);
          }}
          title={use_page_num + ""}>P.{strFunc.str_pad({ "str": use_page_num, "pad_length": 3 })}</button>
      }
    </div>
  );
};
export default StudyTitleAswer;